export const navigation = [
	{
		text: 'Munkaigény bejelentés',
		icon: 'checklist',
		path: '/work-request-list',
	},
];
